jQuery($ => {
	$('figure.is-gallery').each(function () {
		const $images = $(this).find('img').not('.only-thumbnail');
		$images.each(function(idx){
			$(this).attr('title', (idx+1) + '/' + $images.length + ' - ' + $(this).attr('title'));
		});
		const galleryId = $(this).attr('data-gallery-id');
		const showCaptions = $(this).attr('data-show-captions') === 'true';
		const gallery = new SimpleLightbox(`figure.is-gallery[data-gallery-id="${galleryId}"] a:not(.only-thumbnail)`, {
			captionPosition: 'outside',
			heightRatio: 0.84,
			scrollZoom: false,
			captions: showCaptions,
			showCounter: false,
		});
		$(`figure.is-gallery[data-gallery-id="${galleryId}"] a.only-thumbnail`).on('click', function(e){
			e.preventDefault();
			gallery.open();
		});
	});
	$('figure.is-video a').click(function(e){
		e.preventDefault();
		const videoIdMatches = this.href.match(/\?v=(.+)&?/);
		if (videoIdMatches) {
			BigPicture({
				el: this,
				ytSrc: videoIdMatches[1],
			});
		}
	});
});
